import { getMicroserviceBaseContext } from '../../constants/api-routing';

const chatContext = getMicroserviceBaseContext('chat');

export const CHAT_SERVICE = {
    getChatStream: `${chatContext}stream`,
    getReferenceResponse: `${chatContext}response-overlap`,
    getResponse: `${chatContext}chat`,
    getLLMAgentResponse: `${chatContext}llm_agent_response`,
    getLLMChainResponse: `${chatContext}llm_chain_response`,
    getEmailCoachResponse: `${chatContext}email_coach_response_context`,
    getDownloadUrl2: `${chatContext}generate_reference_doc_url`,
    tokenCount: `${chatContext}token_count`,
}
